import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\User\DeleteUserTokenController::__invoke
* @see app/Http/Controllers/User/DeleteUserTokenController.php
* @route '/api/user/{user}/token/{token}'
*/
const DeleteUserTokenController = (args: { user: string | { id: string }, token: string | number } | [user: string | { id: string }, token: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteUserTokenController.url(args, options),
    method: 'delete',
})

DeleteUserTokenController.definition = {
    methods: ["delete"],
    url: '/api/user/{user}/token/{token}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\User\DeleteUserTokenController::__invoke
* @see app/Http/Controllers/User/DeleteUserTokenController.php
* @route '/api/user/{user}/token/{token}'
*/
DeleteUserTokenController.url = (args: { user: string | { id: string }, token: string | number } | [user: string | { id: string }, token: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            user: args[0],
            token: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: typeof args.user === 'object'
        ? args.user.id
        : args.user,
        token: args.token,
    }

    return DeleteUserTokenController.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace('{token}', parsedArgs.token.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\DeleteUserTokenController::__invoke
* @see app/Http/Controllers/User/DeleteUserTokenController.php
* @route '/api/user/{user}/token/{token}'
*/
DeleteUserTokenController.delete = (args: { user: string | { id: string }, token: string | number } | [user: string | { id: string }, token: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteUserTokenController.url(args, options),
    method: 'delete',
})

export default DeleteUserTokenController